/** @jsx jsx */
import React from 'react'
import {jsx, css} from '@emotion/core'
import styled from '@emotion/styled'

type PopoverMenuLinkProps = {
  /** Label to be shown */
  children: React.ReactNode

  /** The URL for the link to go to */
  url?: string

  /** The link click handler */
  onClick?: (e: any) => void
}

const LinkElement = styled('a')(
  ({theme}) => css`
    display: block;
    text-align: left;
    min-width: 190px;
    margin: 0 ${theme.layout.spacing.s300}px;
    padding: ${theme.layout.spacing.s400}px ${theme.layout.spacing.s500}px;
    ${theme.typography.text.regular};
    color: ${theme.colors.textColor};
    border-radius: ${theme.layout.radius.md}px;
    transition: all 0.1s ease-in-out;
    font-weight: ${theme.fonts.weight.lg};

    &:hover {
      background: ${theme.colors.linkBgColorHover};
      color: ${theme.colors.textColor};
      text-decoration: none;
    }

    &:visited {
      color: ${theme.colors.textColor};
    }
  `
)

const PopoverMenuLink = ({
  children,
  url = '#',
  onClick = () => {}
}: PopoverMenuLinkProps) => {
  return (
    <LinkElement href={url} onClick={onClick}>
      {children}
    </LinkElement>
  )
}

export default PopoverMenuLink
